import { colors } from '../../colors'

interface GuidelinesLinkProps {
  onClick: () => void
}

const styles: Record<string, React.CSSProperties> = {
  message: {
    color: colors['text-secondary'],
    fontSize: 12,
    fontWeight: 300,
  },
  link: {
    color: "#3C1C1C",
    textDecoration: 'underline',
  }
}

const GuidelinesLink: React.FC<GuidelinesLinkProps> = ({ onClick }) => {
  return (
    <div style={styles.message}>
      投稿することで<span style={styles.link} onClick={onClick}>ご利用ガイドライン</span>に同意したことになります。
    </div>
  )
}

export default GuidelinesLink
